<template>
	<div>
		<AppHeader title="1:1 문의" is-history />

		<AppContent>
			<InquiryList />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import InquiryList from '@/components/Inquiry/InquiryList';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		InquiryList,
	},
};
</script>
